import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

const CHOICES = {
  TOUR: "tour",
  IMMERSIVE_3D_TOUR: "immersive3dTour",
};

class SyndicationWidget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      choice: null,
    };
  }

  render() {
    const {
      canSyndicateStandardTour,
      cannotSyndicateReasons,
      canSyndicateImmersive3dTour,
      mlsService,
      syndicationTerms,
      tourSyndicationUrl,
      immersive3dTourSyndicationUrl,
    } = this.props;

    const { choice } = this.state;

    let content = null;

    if (canSyndicateStandardTour && canSyndicateImmersive3dTour) {
      let action = "";

      if (choice === CHOICES.TOUR) {
        action = tourSyndicationUrl;
      } else if (choice === CHOICES.IMMERSIVE_3D_TOUR) {
        action = immersive3dTourSyndicationUrl;
      } else {
        action = "";
      }

      content = (
        <form onSubmit={() => this.onSubmit()}>
          <div>
            <strong>* Please note that only one of the URLs can be syndicated to BrightMLS</strong>
          </div>
          <div>
            <input
              onChange={() => this.setState({ choice: CHOICES.TOUR })}
              type="radio"
              id="tour"
              name="syndication"
              value="tour"
              checked={choice === CHOICES.TOUR}
            />
            <label htmlFor="tour">
              Syndicate the Single Property Website to <strong>{mlsService}</strong>
            </label>
          </div>
          <div>
            <input
              onChange={() => this.setState({ choice: CHOICES.IMMERSIVE_3D_TOUR })}
              type="radio"
              id="immersive3dTour"
              name="syndication"
              value="immersive3dTour"
              checked={choice === CHOICES.IMMERSIVE_3D_TOUR}
            />
            <label htmlFor="immersive3dTour">
              Syndicate the Immersive 3D Tour to <strong>{mlsService}</strong>
            </label>
          </div>
          <a
            className={cx("button primary", { disabled: choice === null })}
            onClick={e => {
              if (!action) {
                e.preventDefault();
              }
            }}
            href={action}
            target="_blank"
            rel="noopener noreferrer"
          >
            Syndicate
          </a>
        </form>
      );
    } else if (canSyndicateStandardTour) {
      content = (
        <div>
          To syndicate the Single Property Website to <strong>{mlsService}</strong>,{" "}
          <a href={tourSyndicationUrl} target="_blank" rel="noopener  noreferrer">
            click here
          </a>
        </div>
      );
    } else if (canSyndicateImmersive3dTour) {
      content = (
        <div>
          To syndicate the Immersive 3D Tour to <strong>{mlsService}</strong>,{" "}
          <a href={immersive3dTourSyndicationUrl} target="_blank" rel="noopener  noreferrer">
            click here
          </a>
        </div>
      );
    }

    return (
      <div>
        {content}
        {syndicationTerms ? <div className="help">{syndicationTerms}</div> : null}
        {cannotSyndicateReasons.length > 0 && (
          <div className="cannotSyndicateReasons">
            <div>Your standard tour cannot be syndicated to {mlsService} for the following reason(s)...</div>
            <ul>
              {cannotSyndicateReasons.map(reason => (
                <li key={reason}>{reason}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  }
}

SyndicationWidget.propTypes = {
  canSyndicateStandardTour: PropTypes.bool,
  canSyndicateImmersive3dTour: PropTypes.bool,
  cannotSyndicateReasons: PropTypes.array.isRequired,
  mlsService: PropTypes.string,
  syndicationTerms: PropTypes.string,
  tourSyndicationUrl: PropTypes.string,
  immersive3dTourSyndicationUrl: PropTypes.string,
};

export default SyndicationWidget;
